import { IUserCertificationsInfo } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const userCertificationsAdapter: EntityAdapter<IUserCertificationsInfo> = createEntityAdapter<IUserCertificationsInfo>({
	selectId: certs => certs.userId
});